import { useEffect } from "react";

const SITE_URL = "https://leafalchemy.shop";
const DEFAULT_IMAGE = `${SITE_URL}/brand/logo.png`;
const DEFAULT_TITLE = "Leaf Alchemy | Premium Tea Powder Manufacturer & Bulk Supplier";
const DEFAULT_DESC =
  "Leaf Alchemy supplies premium tea powder, hotel-grade tea powder, masala tea powder, elaichi tea powder and bulk tea powder across India for restaurants, hotels, tea outlets and distributors.";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(data) {
  if (!data) return;
  let el = document.head.querySelector('script[data-ld="leafalchemy"]');
  if (!el) {
    el = document.createElement("script");
    el.setAttribute("type", "application/ld+json");
    el.setAttribute("data-ld", "leafalchemy");
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function useSEO({ title, description, image, path, robots, structuredData } = {}) {
  useEffect(() => {
    const t = title ? `${title} | Leaf Alchemy` : DEFAULT_TITLE;
    const d = description || DEFAULT_DESC;
    const ogImage = image || DEFAULT_IMAGE;
    const url = new URL(path || window.location.pathname, SITE_URL).toString();

    document.title = t;
    setMeta("description", d);
    setMeta("robots", robots || "index,follow,max-image-preview:large");
    setMeta("og:title", t, "property");
    setMeta("og:description", d, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:image", ogImage, "property");
    setMeta("og:image:alt", t, "property");
    setMeta("og:url", url, "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", t);
    setMeta("twitter:description", d);
    setMeta("twitter:image", ogImage);
    setCanonical(url);
    setJsonLd(structuredData || null);
  }, [title, description, image, path, robots, structuredData]);
}
